import { useFormContext } from "react-hook-form";
import {
  edsn_Marktrol,
  RegistrationCreateDto,
} from "../../../openapi/edsn-webapi";
import ContactControl from "../ContactControl";
import OptionalContactControl from "../OptionalContactControl";

type contactDetailStepProps = {
  isCreate?: boolean;
};

const ContactDetailStep = ({ isCreate }: contactDetailStepProps) => {
  const { watch } = useFormContext<RegistrationCreateDto>();
  const marketRole = watch("marketRole")
  const isLv = marketRole === edsn_Marktrol.LVLEVERANCIER;
  const isMv = marketRole === edsn_Marktrol.MVMEETVERANTWOORDELIJKE;
  const isPv = marketRole === edsn_Marktrol.PVPROGRAMMAVERANTWOORDELIJKE;
  const isGds = marketRole === edsn_Marktrol.GDSEIGENAAR_GESLOTEN_DISTRIBUTIE_SYSTEEM;

  return (
    <>
      <ContactControl fieldname="contactDefault" />
      {isLv && isCreate && (
        <>
          <OptionalContactControl
            nameBool="contactProcessTransferDifferentThanDefault"
            name="contactProcessTransfer"
            label="contactProcessTransferTitle"
            TooltipTitle="contactProcessTransferTooltipTitle"
          />
          <OptionalContactControl
            nameBool="contactAtoDifferentThanDefault"
            name="contactAto"
            label="contactAtoTitle"
            TooltipTitle="contactAtoTooltipTitle"
          />
          <OptionalContactControl
            nameBool="contactPeriodicNetworkRatesDifferentThanDefault"
            name="contactPeriodicNetworkRates"
            label="contactPeriodicNetworkRatesTitle"
            TooltipTitle="contactPeriodicNetworkRatesTooltipTitle"
          />
          <OptionalContactControl
            nameBool="contactTocDifferentThanDefault"
            name="contactToc"
            label="contactTocTitle"
            TooltipTitle="contactTocTooltipTitle"
          />
        </>
      )}
      {(isLv || isMv || isPv) && isCreate && (
        <OptionalContactControl
          nameBool="contactSecurityOfSupplyDifferentThanDefault"
          name="contactSecurityOfSupply"
          label="contactSecurityOfSupplyTitle"
          TooltipTitle="contactSecurityOfSupplyTooltipTitle"
        />
      )}
      {(isLv || isMv || isPv) && isCreate && (
        <OptionalContactControl
          nameBool="contactMeteringCorrectionForLargeConsumersDifferentThanDefault"
          name="contactMeteringCorrectionForLargeConsumers"
          label="contactMeteringCorrectionForLargeConsumersTitle"
          TooltipTitle="contactMeteringCorrectionForLargeConsumersTooltipTitle"
        />
      )}
      {(isLv || isGds) && isCreate && (
        <OptionalContactControl
          nameBool="contactSettlementProcessForLargeConsumerMeteringErrorsDifferentThanDefault"
          name="contactSettlementProcessForLargeConsumerMeteringErrors"
          label="contactSettlementProcessForLargeConsumerMeteringErrorsTitle"
          TooltipTitle="contactSettlementProcessForLargeConsumerMeteringErrorsTooltipTitle"
        />
      )}
    </>
  );
};

export default ContactDetailStep;
